const dataCategories = [
    {
        id: 1,
        name: 'Niños y Niñas',
        url: 'https://www.lippioutdoor.com/kids.html',
        class: 'c3-1'
    },
    {
        id: 2,
        name: 'Calzado',
        url: 'https://www.lippioutdoor.com/calzado.html',
        class: 'c3-2'
    },
    {
        id: 3,
        name: 'Accesorios y equipamiento',
        url: 'https://www.lippioutdoor.com/accesorios-y-equipamiento.html',
        class: 'c3-3'
    },
];

export default dataCategories;